import { dialogTypes } from '@/dialogs'
import { getStore } from '@/store'
import { headerTypes } from '../enums/headerTypes'
import { RowEditorRendererBase } from './rowEditorRendererBase'
import { definitionType } from '@/enums/definitionType'
import { getExistingUserRowCodes } from '@/store/utils/reportUtils'

// Can't connect these, importing instead
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { actionCreators } from '@/store/ReportSubmissions'
import { getPureMetadata } from '../core/utils'

class RowEditorRenderer extends RowEditorRendererBase {
  createRow (name, latinName) {
    const parent = this.props.parent

    getStore().dispatch(actionCreators.createUserRow({ ...getPureMetadata(this.props),
      id: 0,
      name: name,
      latinName: latinName,
      code: `[${name}]`,
      isUserRow: true,
      definitionType: definitionType.enum.Normal,
      fromDefinitionType: this.props.definitionType,
      parent: null,
      parentId: parent ? parent.id !== 0 ? parent.id : null : null,
      headerTemplateId: this.props.reportHeaderTemplateId,
      headerRenderer: null,
      type: headerTypes.Classic,
      order: this.getOrder(),
      row: this.props.row
    }))
  }

  onClick () {
    const store = getStore()
    const state = store.getState()

    store.dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.userRow,
      existingCodes: getExistingUserRowCodes(state.reportSubmissions.userDefCodes, this.props.parentId),
      onAction: value => this.createRow(value.value, value.latinValue)
    }))
  }
}

export { RowEditorRenderer }



// WEBPACK FOOTER //
// ./src/components/report-tables/headers/rowEditorRenderer.js